import { render, staticRenderFns } from "./CookiesInfo.vue?vue&type=template&id=634aeb55&scoped=true&"
import script from "./CookiesInfo.vue?vue&type=script&lang=js&"
export * from "./CookiesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634aeb55",
  null
  
)

export default component.exports